/** get unique string of 8 charatcter */
const keyUniqueID = () => {
    let date = new Date();
    let year = date.getFullYear().toString().slice(-2);
    let number = Math.random();
    number.toString(36);
    let uid = number.toString(36).substr(2, 6);
    return uid + year;
}

const RepeaterArray = [
    { 'type': 'choose', 'value': 'align_defaultValue' },
    { 'type': 'select', 'value': 'select_defaultValue[0]' },
    { 'type': 'select2', 'value': 'select2_defaultValue' },
    { 'type': 'dimension', 'value': 'dimension_defaultValue' },
    { 'type': 'slider', 'value': 'slider_defaultValue' },
    { 'type': 'selecttemplate', 'value': 's_template_defaultValue' }
]

const RepeaterDefault = (controller) => {
    if (controller.type == 'select') {
        return controller.select_defaultValue[0];
    } else if (controller.type == 'choose') {
        return controller.align_defaultValue;
    } else if (controller.type == 'select2') {
        return controller.select2_defaultValue?.[0]?.value ? controller.select2_defaultValue?.[0]?.value : [];
    } else if (controller.type == 'dimension') {
        return '';
    } else if (controller.type == 'slider') {
        return '';
    } else if (controller.type == 'selecttemplate') {
        return controller.s_template_defaultValue;
    } else {
        return controller.defaultValue;
    }
}

export const Temp_component = (item, type, loop, nha) => {
    var sec_layouttest = "";
    var php_file = "";
    var textdomain = "wdesignkit";

    let deafault_valus_obj = {
        choose: "align_defaultValue",
        slider: "slider_defaultValue",
        select: "select_defaultValue",
        select2: "select2_defaultValue",
        hTags: "hTags_defaultValue",
        dimension: "dimension_defaultValue",
    };

    const Condition_value = (switcher, object) => {
        let condition = "";
        if (object && object.relation && switcher && switcher == true) {
            let relation = object.relation == "or" ? "||" : object.relation == "and" ? "&&" : "";

            object.values.map((conditions) => {
                if (conditions.name && conditions.operator) {
                    if (conditions.value == "true" || conditions.value == "false" || conditions.value == "null") {
                        condition ? condition += relation : condition += "(";
                        condition += ` ${conditions.name} ${conditions.operator} ${conditions.value} `;
                    } else {
                        condition ? condition += relation : condition += "(";
                        condition += ` ${conditions.name} ${conditions.operator} "${conditions.value}" `;
                    }
                }
            })
            condition ? condition += ") &&" : "";
        }

        return condition;
    }

    if (item.type == "text") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Text, {
                ${item.lable ? `label: __("${item.lable}"),` : ''}
                type: "${item.type}",
                value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
                ${item.placeHolder ? `placeholder:"${item.placeHolder}",` : ''}
                ${item.separator ? `separator:"${item.separator}",` : ''}
                ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
                ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }),\n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'string',
            'default' => \'${item.defaultValue}\'
        ),\n`

    } else if (item.type == "url") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Url, {
                ${item.lable ? `label: __("${item.lable}"),` : ''}
                type: "${item.type}",
                value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
                ${item.placeHolder ? `placeholder:"${item.placeHolder}",` : ''}
                ${item.separator ? `separator:"${item.separator}",` : ''}
                ${item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
                ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }),\n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'object',
            'default' => array(
                'url' => \'${item.defaultValue}\',
                ${item.is_external ? `'target' => true,` : ''}
                ${item.nofollow ? `'nofollow' => 'no-follow'` : ''}
            ),

        ),\n`

    } else if (item.type == "number") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Text, {
                ${item.lable ? `label: __("${item.lable}"),` : ''}
                type: "${item.type}",
                value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
                ${item.placeHolder ? `placeholder:"${item.placeHolder}",` : ''}
                ${item.separator ? `separator:"${item.separator}",` : ''}
                ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
                ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }),\n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
        'type' => 'string',
        'default' => \'${item.defaultValue}\',
        ${(item.selectors || item.selector_value) ? `'style' => array(
            (object) array(
                'selector' => '{{PLUS_WRAP}} ${item.selectors}{${item.selector_value}:{{${item.name}${nha ? nha : ""}}};}',
            ),
        ),` : ''}
    ),\n`
    } else if (item.type == "select") {
        let options = "";
        if (item.options.length > 0) {
            options += "[";
            item.options.map((opt) => {
                options += `['${opt.value}',__('${opt.lable}')],`
            })
            options += "]";
        }
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Select, {
                ${item.lable ? `label: __("${item.lable}"),` : ''}
                options:${options},
                ${item.separator ? `separator:"${item.separator}",` : ''}
                ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
                value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
                ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }),\n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'string',
            'default' => '${item.select_defaultValue[0]}'
        ),\n`
    } else if (item.type == "select2") {
        let options = "";
        var D_val = [];

        if (item.options.length > 0) {
            options += "[";
            item.options.map((opt) => {
                options += `{'value' : '${opt.value}', 'label' : __('${opt.lable}')},`
            })
            options += "]";
        }

        if (item && item.select2_defaultValue) {
            item.select2_defaultValue.map((data) => {
                D_val.push(`['value' => '${data.value}', 'label' => '${data.lable}']`)
            })
        }

        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_select2, {
                ${item.lable ? `label: __("${item.lable}"),` : ''}
                options:${options},
                ${item.separator ? `separator:"${item.separator}",` : ''}
                ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
                ${item.multiple ? `isMulti: ${item.multiple},` : ''}
                value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
                ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }),\n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'string',
            'default' => array(${D_val}),
        ),\n`
    } else if (item.type == "textarea") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_TextArea, {
                ${item.lable ? `label: __("${item.lable}"),` : ''}
                ${item.separator ? `separator:"${item.separator}",` : ''}
                ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
                rows:"${item.rows}",
                value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
                ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }),\n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'string',
            'default' => \'${item.defaultValue}\',
        ),\n`
    } else if (item.type == "dimension") {
        let condition = Condition_value(item.conditions, item.condition_value)
        let size_units = '';

        if (item.dimension_units) {
            item.dimension_units.map((unit) => {
                size_units += `'${unit}',`
            })
        }

        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Dimension, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            noLock: false,
            unit: [${size_units}],
            ${item.separator ? `separator:"${item.separator}",` : ''}
            ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            responsive: true,
            device: this.state.device,
            onDeviceChange: (value) => this.setState({ device: value }),
        }),\n`
        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'object',
            'default' => (object) array(
                'md' => array(
                    "top" => ${item.dimension_defaultValue.top ? item.dimension_defaultValue.top : '""'},
                    "right" => ${item.dimension_defaultValue.right ? item.dimension_defaultValue.right : '""'},
                    "bottom" => ${item.dimension_defaultValue.bottom ? item.dimension_defaultValue.bottom : '""'},
                    "left" => ${item.dimension_defaultValue.left ? item.dimension_defaultValue.left : '""'},
                ),
                "unit" => "${item.dimension_defaultValue.unit}",
            ),
            ${(item.selectors || item.selector_value) ? `'style' => array(
                (object) array(
                    'selector' => '{{PLUS_WRAP}} ${item.selectors}{ ${item.selector_value}: {{${item.name}${nha ? nha : ""}}}}',
                ),
            ),` : ''}
        ), \n`
    } else if (item.type == "color") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Color, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            disableAlpha: "${item.separator}",
            ${item.separator ? `separator:"${item.separator}",` : ''}
            ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }), \n`
        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'string',
            'default' => '${item.defaultValue}',
            ${(item.selectors || item.selector_value) ? `'style' => array(
                (object) array(
                    'selector' => '{{PLUS_WRAP}} ${item.selectors}{${item.selector_value}:{{${item.name}${nha ? nha : ""}}};}',
                ),
            ),` : ''}
        ), \n`
    } else if (item.type == "gradientcolor") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Gradient, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            ${item.separator ? `separator:"${item.separator}",` : ''}
            ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }), \n`
        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'string',
            'default' => '${item.defaultValue}',
            ${(item.selectors || item.selector_value) ? `'style' => array(
                (object) array(
                    'selector' => '{{PLUS_WRAP}} ${item.selectors}{${item.selector_value}:{{${item.name}${nha ? nha : ""}}};}',
                ),
            ),` : ''}
        ), \n`
    } else if (item.type == "switcher") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Toggle, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }      
            }), \n`
        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'boolean',
            'default' => ${item.defaultValue == true ? true : false},
        ), \n`
    } else if (item.type == "heading") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Label_Heading, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            ${item.separator ? `separator:"${item.separator}",` : ''}
            inlineblock: ${true},
            }), \n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'string',
        ), \n`
    } else if (item.type == "border") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Border, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            ${item.separator ? `separator:"${item.separator}",` : ''}
            ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            responsive: true,
            device: this.state.device,
            onDeviceChange: (value) => this.setState({ device: value }),
            }), \n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'object',
            'default' =>(object) array(
                'openBorder' => 0,
                'type' => '',
                'color' => '',
                'width' =>(object) array(
                    'md' =>(object)array(
                        'top' => '',
                        'left' => '',
                        'bottom' => '',
                        'right' => '',
                    ),
                    'sm' =>(object)array(),
                    'xs' =>(object)array(),
                    "unit" => "",
                ),
            ),
            ${item.selector ? `'style' => array(
                (object) array(
                    'selector' => '{{PLUS_WRAP}} ${item.selector}',
                ),
            ),` : ''}

        ), \n`
    } else if (item.type == "boxshadow") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_BoxShadow, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            ${item.separator ? `separator:"${item.separator}",` : ''}
            ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }), \n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'object',
            'default' =>(object) array(
                'openShadow' => 0,
                'inset' => 0,
                'horizontal' => 0,
                'vertical' => 4,
                'blur' => 8,
                'spread' => 0,
                'color' => "rgba(0,0,0,0.40)",
            ],
            ${item.selector ? `'style' => array(
                    (object) array(
                        'selector' => '{{PLUS_WRAP}} ${item.selector}',
                    ),
                ),` : ''}
            ), \n`
    } else if (item.type == "textshadow") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_BoxShadow, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            istextShadow: true,
            ${item.separator ? `separator:"${item.separator}",` : ''}
            ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }), \n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'object',
            'default' =>(object) array(
                'openShadow' => 0,
                'typeShadow' => 'text-shadow', //"text-shadow" Or "drop-shadow"
                'horizontal' => 2,
                'vertical' => 3,
                'blur' => 2,
                'color' => "rgba(0,0,0,0.5)",
            ),
            ${item.selector ? `'style' => array(
                (object) array(
                    'selector' => '{{PLUS_WRAP}} ${item.selector}',
                ),
            ),` : ''}
        ), \n`
    } else if (item.type == "background") {
        let condition = Condition_value(item.conditions, item.condition_value);
        var bg_source = [];


        if (item.types.length > 0) {
            item.types.map((src) => {
                if (src == `"classic"`) {
                    bg_source.push(`"color"`)
                    bg_source.push(`"image"`)
                } else {
                    bg_source.push(src)
                }
            })
        }

        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Background, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            sources: [${bg_source}],
            parallax: true,
            position: true,
            size: true,
            repeat: true,
            attachment: true,
            ${item.separator ? `separator:'${item.separator}',` : ''}
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }), \n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'object',
            'default' =>(object) array(
            'openBg'=> 0,
            'bgType' => 'color',
            'videoSource' => 'local',
            'bgDefaultColor' => '',
            'bgGradient' =>(object) array('color1' => '#16d03e', 'color2' => '#1f91f3', 'type' => 'linear', 'direction' => '90', 'start' => 5, 'stop' => 80, 'radial' => 'center', 'clip' => false),
            ),
            ${item.selector ? `'style' => array(
                (object) array(
                    'selector' => '{{PLUS_WRAP}} ${item.selector}',
                ),
            ),` : ''}
        ), \n`
    } else if (item.type == "typography") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Typography, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            ${item.separator ? `separator:'${item.separator}',` : ''}
            device: this.state.device,
            onDeviceChange: (value) => this.setState({ device: value }),
            }), \n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'object',
            'default'=>(object) array(
                'openTypography' => 0,
                'size' => array('md' => 20, 'unit' => 'px'),
                'height' => array('md' => 22, 'unit' => 'px'),
                'spacing' => array('md' => 0.1, 'unit' => 'px'),
                'fontFamily' => array(
                    'family' => '',
                    'fontWeight' => 400,
                ),
                'fontStyle' => 'Default',
                'textTransform' => 'None',
                'textDecoration' => 'Default',
            ),
            ${item.selector ? `'style' => array(
                (object) array(
                    'selector' => '{{PLUS_WRAP}} ${item.selector}',
                ),
            ),` : ''}
        ), \n`
    } else if (item.type == "cssfilter") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_CssFilter, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            ${item.separator ? `separator:'${item.separator}',` : ''}
            }), \n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'object',
            'default' => array(
                'openFilter' => false,
                'blur' => 0,
                'brightness' => 100,
                'contrast' => 100,
                'saturate' => 100,
                'hue' => 0,
            ),
            ${item.selector ? `'style' => array(
                (object) array(
                    'selector' => '{{PLUS_WRAP}} ${item.selector}',
                ),
            ),` : ''}
        ), \n`
    } else if (item.type == "media") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Media, {
                ${item.lable ? `label: __("${item.lable}"),` : ''}
                multiple: false,
                ${item.separator ? `separator:'${item.separator}',` : ''}
                value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
                panel: true,
                ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
                ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
                }), \n`
        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'object',
            'default' => array(
                'url' => '${item.defaultValue}',
                'Id' => '',
            ),
        ), \n`
    } else if (item.type == "gallery") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Media, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            multiple: true,
            ${item.separator ? `separator:'${item.separator}',` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            panel: true,
            ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }), \n`
        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'array',
            'default' => array(
                (object) array('url' => '', 'Id' => ''),
            ),
        ), \n`
    } else if (item.type == "iconscontrol") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_IconList, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
                                                        ${item.separator ? `separator:'${item.separator}',` : ''}
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }), \n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'object',
            'default'=> '${item.defaultValue}',
        ), \n`
    } else if (item.type == "slider") {
        let range_units = "";
        if (item.size_units.length > 0) {
            item.size_units.filter((units) => {
                if (units.checked = true) {
                    return units;
                }
            }).map((units) => {
                range_units += `'${units.type}', `
            })
        }
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Range, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            ${item.separator ? `separator:'${item.separator}',` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            min: ${loop ? "value." : ""}${item.name}${nha ? nha : ""} && ${loop ? "value." : ""}${item.name}${nha ? nha : ""}.unit ? ${item.name}${nha ? nha : ""}Function(${loop ? "value." : ""}${item.name}${nha ? nha : ""}.unit, 'min') : 0,
            max: ${loop ? "value." : ""}${item.name}${nha ? nha : ""} && ${loop ? "value." : ""}${item.name}${nha ? nha : ""}.unit ? ${item.name}${nha ? nha : ""}Function(${loop ? "value." : ""}${item.name}${nha ? nha : ""}.unit, 'max') : 100,
            step: ${loop ? "value." : ""}${item.name}${nha ? nha : ""} && ${loop ? "value." : ""}${item.name}${nha ? nha : ""}.unit ? ${item.name}${nha ? nha : ""}Function(${loop ? "value." : ""}${item.name}${nha ? nha : ""}.unit, 'step') : 1,
            unit: [${range_units}],
            responsive: true,
            device: "device",
            responsive: true,
            device: this.state.device,
            onDeviceChange: (value) => this.setState({ device: value }),
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }), \n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'string',
            'default' => '',
            ${(item.selectors || item.selector_value) ? `'style' => array(
                (object) array(
                    'selector' => '{{PLUS_WRAP}} ${item.selectors}{${item.selector_value}:{{${item.name}${nha ? nha : ""}}};}',
                ),
            ),` : ''}
        ), \n`
    } else if (item.type == "choose") {
        let condition = Condition_value(item.conditions, item.condition_value)
        let array = ['eicon-text-align-left', 'eicon-text-align-right', 'eicon-text-align-center', 'eicon-text-align-justify', 'eicon-arrow-up', 'eicon-arrow-down', 'eicon-arrow-right', 'eicon-arrow-left', 'align_title', 'align_svg'];

        var options = "";
        if (item.align_option.length > 0) {
            var options = "";
            options += `[`
            item.align_option.map((data) => {
                var icon = '';
                if (data.align_icon == 'align_svg' || data.align_icon == 'align_title') {
                    icon = '';
                } else {
                    icon = data.align_icon;
                }

                options += `{ label: __('${data.align_lable}'), value: '${data.align_value}', title: __('${data.align_title ? data.align_title : ""}'), icon: '${icon}', svg: '${data.align_svg ? data.align_svg : ""}' }, \n`
            })
            options += `]`
        }
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_RadioAdvanced, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            ${item.separator ? `separator:'${item.separator}',` : ''}
            options : ${options},
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
            responsive: true,
            device: this.state.device,
            onDeviceChange: (value) => this.setState({ device: value }),
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }), \n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'string',
            'default' => 'center',
            ${(item.selectors || item.selector_value) ? `'style' => array(
                (object) array(
                    'selector' => '{{PLUS_WRAP}} ${item.selectors}{ ${item.selector_value}: {{${item.name}${nha ? nha : ""}}}; }',
                ),
            ),` : ''}
        ), \n`
    } else if (item.type == "popover") {
        let condition = Condition_value(item.conditions, item.condition_value);
        let fields_data = "";
        let fields_php = "";
        let repeater_default_value = "";
        item.fields.map((controller) => {
            fields_data += Temp_component(controller, "js", item.name);
        })
        item.fields.map((controller) => {
            fields_php += Temp_component(controller, "php");
        })

        if (item.fields) {
            if (item.fields.length > 0) {
                repeater_default_value += `[`;
                item.fields.map((controller) => {
                    repeater_default_value += `'${controller.name}' => esc_html__('${RepeaterDefault(controller)}', '${textdomain}'), \n`;
                })
                repeater_default_value += `]\n`;
            }
        }

        sec_layouttest +=
            `${condition} React.createElement(Pmgc_GroupPopover, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${item.name + (nha ? nha : "")},
            onChange: value => setAttributes({ ${item.name}${nha ? nha : ""}: value }),
            },
            (value, onChange) => {
                return [
                    React.createElement(Fragment, null,
                        ${fields_data}
                    )]
            }), \n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'object',
            'groupField' => array(
                (object) array(
                    ${fields_php}
                )
            ),
            'default' => ${repeater_default_value},
        ), \n`
    } else if (item.type == "normalhover") {
        let condition = Condition_value(item.conditions, item.condition_value);
        let fields_php_normal = "";

        sec_layouttest += `${condition} React.createElement(Pmgc_Tabs, null, `;
        item?.nha_array?.length > 0 && item.nha_array.map((type, index) => {
            if (item.nha_array_lable?.[index]) {
                var type_label = item.nha_array_lable[index].charAt(0).toUpperCase() + item.nha_array_lable[index].slice(1);
            } else {
                if (index == 0) {
                    var type_label = 'Normal';
                } else if (index == 1) {
                    var type_label = 'Hover';
                } else if (index == 2) {
                    var type_label = 'Active';
                } else {
                    var type_label = `Tab - ${index}`;
                }
            }

            sec_layouttest += `React.createElement(Pmgc_Tab, {
                                tabTitle: __('${type_label}')
                            }, `
            item.fields.map((controller) => {
                if (controller.key == type) {
                    sec_layouttest += Temp_component(controller, "js", "", `_${type}`);
                    fields_php_normal += Temp_component(controller, "php", "", `_${type}`);
                }
            })
            sec_layouttest += `), \n`
        })

        sec_layouttest += `), \n`

        php_file += `${fields_php_normal}\n`
    } else if (item.type == "repeater") {
        let condition = Condition_value(item.conditions, item.condition_value);
        let fields_data = "";
        let fields_php = "";
        var repeater_default_value = "";

        item.fields.map((controller) => {
            fields_data += Temp_component(controller, "js", item.name);
        })
        item.fields.map((controller) => {
            fields_php += Temp_component(controller, "php");
        })

        if (item.fields.length > 0) {
            repeater_default_value += `array(\n '_key' => '0', \n`;
            item.fields.map((controller) => {
                repeater_default_value += `'${controller.name}' => esc_html__('${RepeaterDefault(controller)}', '${textdomain}'), \n`;
                // })
            })
            repeater_default_value += '),';
        }

        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Repeater, {
            // max: 10,
            ${item.lable ? `labelText:__('${item.lable}'),` : ''}
            value: ${item.name + (nha ? nha : "")},
            attributeName: '${item.name + (nha ? nha : "")}',
            addText: 'Add Item',
            ${item.title_field ? `titleField: '{${item.title_field}}',` : ''}
            onChange: value => setAttributes({ ${item.name}${nha ? nha : ""}: value }),
            },
            (value, onChange) => {
                return [
                    React.createElement(Fragment, null,
                        ${fields_data}
                    )]
            }), \n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'array',
            'repeaterField' => array(
                (object) array(
                    ${fields_php}
                )
            ),
            'default' => array(${repeater_default_value}),
        ), \n`
    } else if (item.type == "rawhtml") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Note, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            ${item.defaultValue ? `description: '${item.defaultValue}',` : ''}
            ${item.separator ? `separator:"${item.separator}",` : ''}
            ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
                                                                            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }), \n`
    } else if (item.type == "headingtags") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(Pmgc_Heading, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            value: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            ${item.separator ? `separator:"${item.separator}",` : ''}
            ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }), \n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(
            'type' => 'string',
            'default' => '${item.select_defaultValue[0]}'
        ), \n`
    } else if (item.type == "styleimage") {
        let options = "";
        if (item.options.length > 0) {
            options += `array(`;
            item.options.map((opt) => {
                options += `{ 'value': '${opt.value}', 'lable': __('${opt.lable}'), 'svg': __('${opt.svg}'), }, `;
            });
            options += `)`;
        }

        let condition = Condition_value(item.conditions, item.condition_value);
        sec_layouttest += `${condition} React.createElement(Pmgc_Styles, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            columns: '${item.columns}',
            ${item.separator ? `separator:'${item.separator}',` : ''}
            value: ${item.name},
            options: ${options},
            onChange: (value) => setAttributes({ ${item.name}: value }),
            }), \n`;
        php_file += `'${item.name}' => array(
            'type' => 'string',
            'default' => \`${item.select_defaultValue[0]}\`,
        ),\n`;
    } else if (item.type == "datetime") {
        let condition = Condition_value(item.conditions, item.condition_value)
        sec_layouttest +=
            `${condition} React.createElement(DateTimePicker, {
            ${item.lable ? `label: __("${item.lable}"),` : ''}
            currentDate: ${loop ? "value." + item.name : item.name + (nha ? nha : "")},
            ${item.separator ? `separator:"${item.separator}",` : ''}
            ${!item.lableBlock ? `inlineblock:${!item.lableBlock},` : ''}
            is12Hour: true,
            ${loop ?
                `onChange: v => { value.${item.name} = v; onChange(value); },`
                :
                `onChange: (value) => setAttributes({ ${item.name}${nha ? nha : ""}: value }),`
            }
            }),\n`

        php_file += `'${item.name}${nha ? nha : ""}' => array(),\n`

    }

    if (type == "php") {
        return php_file;
    } else if (type == "js") {
        return sec_layouttest;
    }
}

export const Elementer_data = (item, repeater) => {
    /** condition function for controller  */
    const Condition_function = (data) => {
        var condition = ""
        if (data.conditions == true) {
            data.condition_value.values.map((cd_data) => {
                if (cd_data.name == "" || cd_data.operator == "") {
                } else {
                    cd += `array('name' => '${cd_data.name}', 'operator' => '${cd_data.operator}', 'value' => '${cd_data.value}'),\n`
                }
            })
            if (cd == "") {
                condition = "";
            } else {
                condition += `'conditions' => array(
                    'relation' => '${data.condition_value.relation}',
                    'terms' => [${cd}],
                ),`
            }
        }
        return condition;
    }
    var textdomain = "wdesignkit"

    var layout = "";
    var cd = "";
    var group_controles = ["typography", "textshadow", "boxshadow", "textstrocke", "border", "background", "imagesize", "cssfilter"]

    if (item.type == "text") {
        let name = ``;

        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            ${item.title ? `'title' => '${item.title}',` : ''}
            'type' => Controls_Manager::TEXT,
            ${item.defaultValue ? `'default' => esc_html__( '${item.defaultValue}', '${textdomain}' ),` : ''}
            ${item.placeHolder ? `'placeholder' => esc_html__( '${item.placeHolder}', '${textdomain}' ),` : ''}
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.input_type ? `'input_type' => '${item.input_type}',` : ''} 
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${item.dynamic === true ? `'dynamic' => array(
                'active' => ${item.dynamic},
            ),` : ''}
            ${Condition_function(item)}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }

    } else if (item.type == "number") {
        let name = ``,
            min_count = item?.number_setting?.min,
            max_count = item?.number_setting?.max,
            step_count = item?.number_setting?.step;

        var selector_data = ``;

        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        if (item.selectors != '') {
            selector_data += `'selectors' => array(`
            selector_data += `'{{WRAPPER}} ${item.selectors}' => '${item.selector_value}: {{VALUE}}',`
            selector_data += `),`
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::NUMBER,
            'min' => ${(min_count != undefined && min_count != '') ? min_count : '""'},
            'max' => ${(max_count != undefined && max_count != '') ? max_count : '""'},
            'step' => ${(step_count != undefined && step_count != '') ? step_count : '""'},
            'default' => ${(item.defaultValue != undefined && item.defaultValue != '') ? item.defaultValue : '""'},
            ${item.title ? `'title' => '${item.title}',` : ''}
            ${item.placeHolder ? `'placeholder' => esc_html__( '${item.placeHolder}', '${textdomain}' ),` : ''}
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${item.dynamic === true ? `'dynamic' => array(
                'active' => ${item.dynamic},
            ),` : ''}
            ${Condition_function(item)}
            ${selector_data}
        )`

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "repeater") {
        var fields = ``;
        var name = ``;
        var repeater_name = ``;
        var repeater_fields = ``;
        var repeater_default_value = ``;

        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        if (item.repeater_type == "Old") {
            repeater_name += `repeater_${keyUniqueID()}`
        } else if (item.repeater_type == "New") {
            repeater_name = "";
        }

        if (item.fields) {
            repeater_default_value += `array(`;
            for (let i = 0; i < item.defaultCount; i++) {
                if (item.fields.length > 0) {
                    repeater_default_value += `array(`;
                    repeater_default_value += `'_id'=>uniqid('Wkit-${keyUniqueID()}'),\n`;
                    item.fields.map((controller) => {
                        repeater_default_value += `'${controller.name}' => esc_html__( '${RepeaterDefault(controller)}', '${textdomain}' ),\n`;
                    })
                    repeater_default_value += `),\n`;
                }
            }
            repeater_default_value += `)`;
        }

        if (item.fields.length > 0) {
            if (item.repeater_type == "Old") {
                fields += `$${repeater_name}->get_controls(),`
            } else if (item.repeater_type == "New") {
                fields += `array(`
                item.fields.map((data) => {
                    if (!group_controles.includes(data.type)) {
                        fields += `${Elementer_data(data, "")},`
                    }
                })
                fields += `),`
            }
        }

        let layout_array = `array(
                ${name}
				'type' => Controls_Manager::REPEATER,
				${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
                ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
                ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
                ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
                ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
                ${item.title_field ? `'title_field' => '${item.title_field}',` : ''}
				'fields' => ${fields ? fields : "array(),"}
                ${repeater_default_value ? `'default' => ${repeater_default_value},` : ''}
                ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
                ${item.prevent_empty === true ? '' : `'prevent_empty' => ${item.prevent_empty},`}     
                ${Condition_function(item)}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            if (item.repeater_type == "Old") {
                item.fields.map((data) => {
                    repeater_fields += Elementer_data(data, repeater_name)
                })
                layout += `$${repeater_name} = new \\Elementor\\Repeater();

                ${repeater_fields}
                
                $this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                    ${layout_array}
                );\n`
            } else {
                layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                    ${layout_array}
                );\n`
            }
        }
    } else if (item.type == 'popover') {
        let name = ``;
        var controllers = ``;

        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        if (item.fields) {
            if (repeater && repeater != undefined) {
                controllers += `$${repeater}->start_popover();\n`
                item.fields.map((controller) => {
                    controllers += Elementer_data(controller, repeater);
                })
                controllers += `$${repeater}->end_popover();\n`
            } else {
                controllers += `$this->start_popover();\n`
                item.fields.map((controller) => {
                    controllers += Elementer_data(controller);
                })
                controllers += `$this->end_popover();\n`
            }
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::POPOVER_TOGGLE,
            ${item.return_value ? `'return_value' => '${item.return_value}',` : ''}
            'default' => 'yes',
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            'label_block' => false,
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${item.dynamic === true ? `'dynamic' => array(
                'active' => ${item.dynamic},
            ),` : ''}
            ${Condition_function(item)}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );
            ${controllers}\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );
            ${controllers}\n`
        }
    } else if (item.type == 'normalhover') {
        let name = ``;
        var controllers = ``;

        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        if (item.fields) {
            if (repeater && repeater != undefined) {
                item.nha_array.length > 0 && item.nha_array.map((type, index) => {
                    if (item.nha_array_lable?.[index]) {
                        var type_label = item.nha_array_lable[index].charAt(0).toUpperCase() + item.nha_array_lable[index].slice(1);
                    } else {
                        if (index == 0) {
                            var type_label = 'Normal';
                        } else if (index == 1) {
                            var type_label = 'Hover';
                        } else if (index == 2) {
                            var type_label = 'Active';
                        } else {
                            var type_label = `Tab-${index}`;
                        }
                    }
                    controllers += `$${repeater}->start_controls_tab(\n
                        '${item.name}_${type}_tab',
                        array(
                            'label' => esc_html__( '${type_label}', '${textdomain}' ),
                        )
                    );\n`
                    item.fields.filter((controller) => {
                        if (controller.key == type) {
                            return controller
                        }
                    }).map((controller) => {
                        controllers += Elementer_data(controller, repeater);
                    })
                    controllers += `$${repeater}->end_controls_tab();\n`
                })
            } else {
                item?.nha_array?.length > 0 && item.nha_array.map((type, index) => {
                    if (item.nha_array_lable?.[index]) {
                        var type_label = item.nha_array_lable[index].charAt(0).toUpperCase() + item.nha_array_lable[index].slice(1);
                    } else {
                        if (index == 0) {
                            var type_label = 'Normal';
                        } else if (index == 1) {
                            var type_label = 'Hover';
                        } else if (index == 2) {
                            var type_label = 'Active';
                        } else {
                            var type_label = `Tab-${index}`;
                        }
                    }
                    controllers += `$this->start_controls_tab(\n
                        '${item.name}_${type}_tab',
                        array(
                            'label' => esc_html__( '${type_label}', '${textdomain}' ),
                        )
                    );\n`
                    item.fields.filter((controller) => {
                        if (controller.key == type) {
                            return controller
                        }
                    }).map((controller) => {
                        controllers += Elementer_data(controller);
                    })
                    controllers += `$this->end_controls_tab();\n`
                })
            }
        }

        let layout_array = `array(
            ${name}
            ${Condition_function(item)}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->start_controls_tabs('${item.name}',
                ${layout_array}
            );
            ${controllers}\n
            $this->end_controls_tabs();`
        } else {
            layout += `$this->start_controls_tabs('${item.name}',
                ${layout_array}
            );
            ${controllers}\n
            $this->end_controls_tabs();`
        }
    } else if (item.type == "wysiwyg") {
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        let layout_array = `array(
                ${name}
                ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
				'type' => Controls_Manager::WYSIWYG,
                ${item.defaultValue ? `'default' => esc_html__( '${item.defaultValue}', '${textdomain}' ),` : ''}
                ${item.placeHolder ? `'placeholder' => esc_html__( '${item.placeHolder}', '${textdomain}' ),` : ''}
                ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
                ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
                ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
                ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
                ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
                ${item.dynamic === true ? `'dynamic' => array(
                    'active' => ${item.dynamic},
                ),` : ''}
                ${Condition_function(item)}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array;
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "code") {
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        let layout_array = `array(
            ${name}
            'type' => Controls_Manager::CODE,
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            'language' => '${item.language}',
            'rows'=> '${item.rows}' ,
            ${item.defaultValue ? `'default' => '${item.defaultValue}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${item.dynamic === true ? `'dynamic' => array(
                'active' => ${item.dynamic},
            ),` : ''}
            ${Condition_function(item)}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "choose") {
        let name = ``;
        var gg = ``;
        var selector_data = ``;


        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        if (item.selectors != "") {
            selector_data += `'selectors' => array(`
            selector_data += `'{{WRAPPER}} ${item.selectors}' => '${item.selector_value}: {{VALUE}}',`
            selector_data += `),`
        }

        if (item.align_option) {
            var align_option = ``;
            align_option += `'options' => array(`;
            item.align_option.map((align) => {
                align_option += `
                    '${align.align_value}' => array(
                        'title' => esc_html__( '${align.align_lable}', '${textdomain}' ),
                        'icon' => '${align.align_icon}',
                    ),
                `;
            })
            align_option += `),`;
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::CHOOSE,
            ${align_option}
            ${item.align_defaultValue ? `'default' => '${item.align_defaultValue}',` : ''}
            'toggle' => true,
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${Condition_function(item)}
            ${selector_data}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "datetime") {
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::DATE_TIME,
            ${item.defaultValue ? `'default' => esc_html__( '${item.defaultValue}', '${textdomain}' ),` : ''}
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${Condition_function(item)}
        )`

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "gallery") {
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }
        let layout_array = `array(
            ${name}
            'label' => esc_html__( '${item.lable}', '${textdomain}' ),
            'type' => Controls_Manager::GALLERY,
            'default' => array(),
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${Condition_function(item)}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }

    } else if (item.type == "background") {
        var selector_data = ``;

        if (item.selector != "") {
            selector_data += `'selector' => '{{WRAPPER}} ${item.selector}',`
        }

        let layout_array = `
        Group_Control_Background::get_type(),
        array(
            'name' => '${item.name}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'types' => [${item.types}],
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${Condition_function(item)}
            ${selector_data}
        )`;

        if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_group_control"}(
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_group_control"}(
                ${layout_array}
            );\n`
        }
    } else if (item.type == "border") {
        var selector_data = ``;
        if (item.selector != "") {
            selector_data += `'selector' => '{{WRAPPER}} ${item.selector}',`
        }
        let layout_array = `
        Group_Control_Border::get_type(),
        array(
            'name' => '${item.name}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${Condition_function(item)}
            ${selector_data}
        )`;
        if (repeater && repeater != undefined) {
            layout += `$${repeater}->add_group_control(
                ${layout_array}
            );\n`
        } else {
            layout += `$this->add_group_control(
                ${layout_array}
            );\n`
        }
    } else if (item.type == "dimension") {
        var selector_data = ``;
        let name = ``;
        let size_units = ``;
        let default_val = ``;

        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        if (item.selectors != "") {
            selector_data += `'selectors' => array(`
            selector_data += `'{{WRAPPER}} ${item.selectors}' => '${item.selector_value}: {{TOP}}{{UNIT}} {{RIGHT}}{{UNIT}} {{BOTTOM}}{{UNIT}} {{LEFT}}{{UNIT}}',`
            selector_data += `),`
        }

        if (item.dimension_units) {
            item.dimension_units.map((unit) => {
                size_units += `'${unit}',`
            })
        }

        if (item.dimension_defaultValue) {
            if (item.dimension_defaultValue.isLinked == true) {
                default_val = `array(
                    'top' => '${item.dimension_defaultValue.top}',
                    'right' => '${item.dimension_defaultValue.top}',
                    'bottom' => '${item.dimension_defaultValue.top}',
                    'left' => '${item.dimension_defaultValue.top}',
                    'unit' => '${item.dimension_defaultValue.unit}',
                    'isLinked' => '${item.dimension_defaultValue.isLinked}',
                )`
            } else if (item.dimension_defaultValue.isLinked == false) {
                default_val = `array(
                    'top' => '${item.dimension_defaultValue.top}',
                    'right' => '${item.dimension_defaultValue.right}',
                    'bottom' => '${item.dimension_defaultValue.bottom}',
                    'left' => '${item.dimension_defaultValue.left}',
                    'unit' => '${item.dimension_defaultValue.unit}',
                    'isLinked' => '${item.dimension_defaultValue.isLinked}',
                )`
            }
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::DIMENSIONS,
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            'size_units' => array(${size_units}),
            ${default_val ? `'default' => ${default_val},` : ''}
            ${item.responsive == true ?
                `'tablet_default' => ${default_val},
                'mobile_default' => ${default_val},
                'widescreen_default' => ${default_val},`
                : ''
            }
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${Condition_function(item)}
            ${selector_data}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "boxshadow") {
        var selector_data = "";

        if (item.selector != "") {
            selector_data += `'selector' => '{{WRAPPER}} ${item.selector}',`
        }

        let layout_array = `
        Group_Control_Box_Shadow::get_type(),
        array(
            'name' => '${item.name}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${Condition_function(item)}
            ${selector_data} 
        )`

        if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_group_control"}(
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_group_control"}(
                ${layout_array}
            );\n`
        }
    } else if (item.type == "textshadow") {
        var selector_data = "";
        if (item.selector != "") {
            selector_data += `'selector' => '{{WRAPPER}} ${item.selector}',`
        }
        let layout_array = `
        Group_Control_Text_Shadow::get_type(),
            array(
				'name' => '${item.name}',
                ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
                ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
                ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
                ${Condition_function(item)}
				${selector_data}
			)`

        if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_group_control"}(
                    ${layout_array}
                );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_group_control"}(
                    ${layout_array}
                );\n`
        }
    } else if (item.type == "color") {
        var selector_data = ``;
        let name = ``;
        if (repeater != undefined && repeater == "") {
            name = `'name' => '${item.name}',`
        }

        if (item.selectors != "") {
            selector_data += `'selectors' => array(`
            selector_data += `'{{WRAPPER}} ${item.selectors}' => '${item.selector_value}: {{VALUE}}',`
            selector_data += `),`
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' =>  Controls_Manager::COLOR,
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}                
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.defaultValue ? `'default' => '${item.defaultValue}',` : ''}
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            'alpha' => ${item.alpha},
            ${item.global === true ? `'global' => array(
                'active' => ${item.global},
            ),` : ''}
            ${Condition_function(item)}
            ${selector_data}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "cssfilter") {
        var selector_data = ``;

        if (item.selector != "") {
            selector_data += `'selector' => '{{WRAPPER}} ${item.selector}',`
        }
        let layout_array = `
			\\Elementor\\Group_Control_Css_Filter::get_type(),
			array(
				'name' => '${item.name}',
                ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
                ${Condition_function(item)}
				${selector_data}
			)`
        if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_group_control"}(
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_group_control"}(
                ${layout_array}
            );\n`
        }
    } else if (item.type == "hidden") {
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::HIDDEN,
            ${item.defaultValue ? `'default' => '${item.defaultValue}',` : ''}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }

    } else if (item.type == "media") {
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::MEDIA,
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            'default' => array(
                'url' => ${item.defaultValue ? `'${item.defaultValue}'` : '\\Elementor\\Utils::get_placeholder_image_src()'},
            ),
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            'media_types' => array(${item.media_types}),
           ${item.dynamic === true ? `'dynamic' => array(
                'active' => ${item.dynamic},
            ),` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${Condition_function(item)}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "typography") {
        var selector_data = ``;

        if (item.selector != "") {
            selector_data += `'selector' => '{{WRAPPER}} ${item.selector}',`
        }

        let layout_array = `
            Group_Control_Typography::get_type(),
			array(
				'name' => '${item.name}',
                ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
                ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
                ${Condition_function(item)}
                ${selector_data}
			)`

        if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_group_control"}(
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_group_control"}(
                ${layout_array}
            );\n`
        }
    } else if (item.type == "heading") {
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::HEADING,
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${Condition_function(item)}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "divider") {
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        let layout_array = `array(
            ${name}
            'type' => Controls_Manager::DIVIDER,
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "rawhtml") {
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::RAW_HTML,
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.defaultValue ? `'raw' => esc_html__( '${item.defaultValue}', '${textdomain}' ),` : ''}
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${Condition_function(item)}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "iconscontrol") {
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::ICONS,
            'fa4compatibility' => 'icon',
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.skin ? `'skin' => '${item.skin}',` : ''}
            ${item.exclude_inline_options ? `'exclude_inline_options' => array('${item.exclude_inline_options}'),` : ''}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${item.defaultValue ? `'default' => array(
                'value' => '${item.defaultValue}',
                'library' => 'fa-solid',
            ),` : ''}
            ${Condition_function(item)}s
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "slider") {
        var selector_data = ``;
        var size_units = ``;
        var range = ``;
        var default_value = ``;
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }
        if (item.size_units != "" && item.size_units != undefined) {
            item.size_units.map((unit) => {
                if (unit.checked == true) {
                    size_units += `"${unit.type}",`;
                    range += `'${unit.type}' => array(
						'min' => ${unit?.min || unit?.min == 0 ? unit?.min : '0'},
						'max' => ${unit?.max || unit?.max == 0 ? unit?.max : '1000'},
						'step' => ${unit?.step || unit?.step == 0 ? unit?.step : '1'},
					),`
                }
            })
            if (size_units && range) {
                size_units = `'size_units' => array( ${size_units} ),`
                range = `'range' => array(${range}),`
            } else {
                size_units = ``;
                range = ``;
            }

        }
        if (item.slider_defaultValue != "" && item.slider_defaultValue != undefined) {
            if (size_units) {
                default_value += `array(
                                    'unit' => '${item.slider_defaultValue[0]}',
                                    'size' => ${item.slider_defaultValue[1] ? item.slider_defaultValue[1] : "''"},
                                )`
            } else {
                default_value += `array(
                                    'size' => ${item.slider_defaultValue[1] ? item.slider_defaultValue[1] : "''"},
                                )`

            }
        }
        if (item.selectors != "") {
            selector_data += `'selectors' => array(`
            if (item && item.show_unit == true && size_units) {
                selector_data += `'{{WRAPPER}} ${item.selectors}' => '${item.selector_value}: {{SIZE}}{{UNIT}};',)`
            } else {
                selector_data += `'{{WRAPPER}} ${item.selectors}' => '${item.selector_value}: {{SIZE}};',)`
            }

        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::SLIDER,
            ${size_units}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${range}
            ${default_value ? `'default' => ${default_value},` : ''}
            ${item.responsive == true ?
                `'tablet_default' => ${default_value},
                'mobile_default' => ${default_value},
                'widescreen_default' => ${default_value},`
                : ''
            }
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            'render_type' => 'ui',
           ${item.dynamic === true ? `'dynamic' => array(
                'active' => ${item.dynamic},
            ),` : ''}
            ${Condition_function(item)}
            ${selector_data}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }

    } else if (item.type == "select") {
        let options = item.options;
        var opt = ""
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        options.map((data) => {
            opt += `'${data.value}'  => esc_html__( '${data.lable}', '${textdomain}' ),`
        })

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::SELECT,
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.select_defaultValue[0] ? `'default' => '${item.select_defaultValue[0]}',` : ''}
            ${Condition_function(item)}
            'options' => array( ${opt} ),
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }

    } else if (item.type == "selecttemplate") {
        var opt = ""
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::SELECT,
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            'default' => '0',
            ${Condition_function(item)}
            'options' => Wdkit_Wb_Elementor_Controller::wdkit_get_templates(),
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }

    } else if (item.type == "select2") {
        let options = item.options;
        var opt = "";
        let name = ``;
        var D_val = [];
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }
        options.map((data) => {
            opt += `'${data.value}'  => esc_html__( '${data.lable}', '${textdomain}' ),`
        })

        if (item && item.select2_defaultValue) {
            // var value = (item.select2_defaultValue.split(","));
            item.select2_defaultValue.map((data) => {
                D_val.push("'" + data.value + "'")
            })
        }

        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::SELECT2,
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            'default' => array(${D_val}),
            ${item.multiple === true ? `'multiple' => ${item.multiple},` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}

            'options' => array( ${opt} ),
            ${Condition_function(item)}
        )`;


        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "textarea") {
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }
        let layout_array = `array(
            ${name}
            'type' => Controls_Manager::TEXTAREA,
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            'rows' => '${item.rows}',
            ${item.placeHolder ? `'placeholder' => esc_html__( '${item.placeHolder}', '${textdomain}' ),` : ''}
            ${item.defaultValue ? `'default' => esc_html__( '${item.defaultValue}', '${textdomain}' ),` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${item.dynamic === true ? `'dynamic' => array(
                'active' => ${item.dynamic},
            ),` : ''}
            ${Condition_function(item)}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "switcher") {
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }
        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::SWITCHER,
            'label_on' => esc_html__( '${item.label_on}', '${textdomain}' ),
            'label_off' => esc_html__( '${item.label_off}', '${textdomain}' ),
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            'return_value' => '${item.return_value}',
            'default' => '${item.defaultValue == true ? item.return_value : ``}',
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            'label_block' => false,
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${Condition_function(item)}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "headingtags") {
        let options = [{ "value": "h1", "lable": "H1" }, { "value": "h2", "lable": "H2" }, { "value": "h3", "lable": "H3" }, { "value": "h4", "lable": "H4" }, { "value": "h5", "lable": "H5" }, { "value": "h6", "lable": "H6" }];
        var opt = ""
        let name = ``;
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }
        options.map((data) => {
            opt += `'${data.value}'  => esc_html__( '${data.lable}', '${textdomain}' ),`
        })
        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::SELECT,
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.select_defaultValue[0] ? `'default' => '${item.select_defaultValue[0]}',` : ''}
            ${Condition_function(item)}
            'options' => array( ${opt} ),
        )`;
        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    } else if (item.type == "url") {
        let name = ``;
        let options_array = [];
        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        if (item.url_options && item.url_options == true && item.url_options_array) {
            options_array += `array(`
            item.url_options_array.map((options) => {
                options_array += `'${options}',`
            })
            options_array += `)`
        } else {
            options_array = false;
        }
        let layout_array = `array(
            ${name}
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => Controls_Manager::URL,
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${item.placeHolder ? `'placeholder' => esc_html__( '${item.placeHolder}', '${textdomain}' ),` : ''}
            'options' => ${options_array},
            'default' => array(
                'url' => '${item.defaultValue}',
                'is_external' => ${item.is_external},
                'nofollow' => ${item.nofollow},
                'custom_attributes' => '${item.custom_attributes}',
            ),
            ${item.showLable === true ? '' : `'show_label' => ${item.showLable},`}
            ${item.lableBlock === false ? '' : `'label_block' => ${item.lableBlock},`}
            ${item.separator !== 'default' ? `'separator' => '${item.separator}',` : ''}
            ${item.controlClass ? `'classes' => '${item.controlClass}',` : ''}
            ${item.dynamic === true ? `'dynamic' => array(
                'active' => ${item.dynamic},
            ),` : ''}
            ${Condition_function(item)}
        )`;

        if (repeater != undefined && repeater == "") {
            layout += layout_array
        } else if (repeater && repeater != undefined) {
            layout += `$${repeater}->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        } else {
            layout += `$this->${item.responsive == true ? "add_responsive_control" : "add_control"}('${item.name}',
                ${layout_array}
            );\n`
        }
    }

    return layout;
}

export const Bricks_data = (item, tabs, repeater) => {

    /** condition function for controller  */
    const Condition_function = (data) => {
        var required = ""
        if (data.conditions == true) {
            data.condition_value.values.map((cd_data) => {
                if (cd_data.name == "" || cd_data.operator == "") {
                } else {
                    cd += `['${cd_data.name}','${cd_data.operator == '==' ? '=' : cd_data.operator}', '${cd_data.value}'],\n`
                }
            })
            if (cd == "") {
                required = "";
            } else {
                required += `'required' =>  [${cd}],`
            }
        }
        return required;
    }

    var textdomain = "wdesignkit",
        layout = "",
        cd = "",
        group_controles = ["typography", "textshadow", "boxshadow", "textstrocke", "border", "background", "imagesize", "cssfilter"];

    if (item.type == "text") {

        let layout_array = `
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'text',
            'spellcheck' => true,
            ${item.defaultValue ? `'default' => esc_html__( '${item.defaultValue}', '${textdomain}' ),` : ''}
            ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }


    } else if (item.type == "number") {
        let layout_array = `
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'number',
            'min' => ${item?.number_setting?.min ? item?.number_setting?.min : '""'},
            'max' => ${item?.number_setting?.max ? item?.number_setting?.max : '""'},
            'step' => ${item?.number_setting?.step ? item?.number_setting?.step : '""'},
            'default' => ${item.defaultValue ? item.defaultValue : 0},
            ${Condition_function(item)}
            ${item.lableBlock === false ? '' : `'inline' =>${item.lableBlock},`}
            ${item.selector_value || item.selectors ? `'css' => [
                [
                    'property' => '${item.selector_value}',
                    'selector' => '${item.selectors}',
                ],
            ],` : ''}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "repeater") {
        var fields = ``;
        var name = ``;
        var repeater_name = ``;
        var repeater_default_value = ``;

        if (repeater == "" && repeater != undefined) {
            name = `'name' => '${item.name}',`
        }

        if (item.repeater_type == "Old") {
            repeater_name += `repeater_${keyUniqueID()}`
        } else if (item.repeater_type == "New") {
            repeater_name = "";
        }

        if (item.fields) {
            repeater_default_value += `[`;
            for (let i = 0; i < item.defaultCount; i++) {
                if (item.fields.length > 0) {
                    repeater_default_value += `[`;
                    item.fields.map((controller) => {
                        repeater_default_value += `'${controller.name}' => esc_html__( '${RepeaterDefault(controller)}', '${textdomain}' ),\n`;
                    })
                    repeater_default_value += `],\n`;
                }
            }
            repeater_default_value += `]`;
        }

        if (item.fields.length > 0) {
            fields += `[`
            item.fields.forEach((data) => {
                if (!group_controles.includes(data.type)) {
                    fields += `\n ${Bricks_data(data, '', "repeater")}`;
                }
            });
            fields += `],`;
        }

        let layout_array = `
            $this->controls['${item.name}'] = [
                'tab' =>  '${tabs}',
                ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
				'type' => 'repeater',
                ${item.title_field ? `'titleProperty' => '${item.title_field}',` : ''}
                ${repeater_default_value ? `'default' => ${repeater_default_value},` : ''}
                ${item.placeHolder ? `'placeholder' => esc_html__( '${item.placeHolder}', '${textdomain}' ),` : ''}
                'fields' => ${fields ? fields : "[]"}
                ${Condition_function(item)}
            ];
        `;
        layout += layout_array;


    } else if (item.type == "textarea") {
        let layout_array = `
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'textarea',
            'rows' => '${item.rows}',
            'spellcheck' => true,
            ${item.defaultValue ? `'default => '${item.defaultValue}',` : ''}
            ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "color") {
        let layout_array = `
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'color',
            ${item.lableBlock === false ? '' : `'inline' =>${item.lableBlock},`}
            ${item.selector_value || item.selectors ? `'css' => [
                [
                    'property' => '${item.selector_value}',
                    'selector' => '${item.selectors}',
                ],
            ],` : ''}            
            ${item.defaultValue ? `'default' => [
              'hex' => '${item.defaultValue}',
            ],` : ''}
            ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "select") {
        let options = item.options;
        var opt = ""
        options.map((data) => {
            opt += `'${data.value}'  => esc_html__( '${data.lable}', '${textdomain}' ),`
        })
        let layout_array = `
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'select',
            'options' => [ ${opt} ],         
            ${item.lableBlock === false ? '' : `'inline' =>${item.lableBlock},`}
            ${item.placeHolder ? `'placeholder' => esc_html__( '${item.placeHolder}', '${textdomain}' ),` : ''}
            'multiple' => false, 
            'searchable' => true,
            'clearable' => true,
            ${item.select_defaultValue[0] ? `'default' => '${item.select_defaultValue[0]}',` : ''}
            ${Condition_function(item)}

        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "select2") {
        let options = item.options;
        var opt = "";
        var D_val = [];
        options.map((data) => {
            opt += `'${data.value}'  => esc_html__( '${data.lable}', '${textdomain}' ),`
        })

        if (item && item.select2_defaultValue) {
            // var value = (item.select2_defaultValue.split(","));
            item.select2_defaultValue.map((data) => {
                D_val.push("'" + data.value + "'")
            })
        }
        let layout_array = `
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'select',
            'options' => [ ${opt} ],
            ${item.lableBlock === false ? '' : `'inline' =>${item.lableBlock},`}
            ${item.placeHolder ? `'placeholder' => esc_html__( '${item.placeHolder}', '${textdomain}' ),` : ''}
            'multiple' => true, 
            'searchable' => true,
            'clearable' => true,
            ${D_val ? `'default' => '${D_val}',` : ''}
            ${Condition_function(item)}

        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "url") {
        let layout_array = `
       
            'tab'         => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type'        => 'link',
            'pasteStyles' => false,
            ${item.placeHolder ? `'placeholder' => esc_html__( '${item.placeHolder}', '${textdomain}' ),` : ''}
            ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "media") {
        let layout_array = `
        
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'image',
            ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "icon") {
        let layout_array = `
        
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'icon',
            'default' => [
              'library' => 'themify', // fontawesome/ionicons/themify
              'icon' => 'ti-star',    // Example: Themify icon class
            ],
            ${Condition_function(item)}
            ${item.selectors ? `'css' => [
              [
                'selector' => '${item.selectors}', // Use to target SVG file
              ],
            ],` : ''}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "slider") {
        var size_units = ``;
        var units = ``;

        if (item.size_units != "" && item.size_units != undefined) {
            item.size_units.map((unit) => {
                if (unit.checked == true) {
                    size_units += `"${unit.type}",`;
                    units += `'${unit.type}' => [
						'min' => ${unit?.min || unit?.min == 0 ? unit?.min : '0'},
						'max' => ${unit?.max || unit?.max == 0 ? unit?.max : '1000'},
						'step' => ${unit?.step || unit?.step == 0 ? unit?.step : '1'},
					],`
                }
            })
            if (size_units && units) {
                size_units = `'size_units' => [ ${size_units} ],`
                units = `'units' => [${units}],`
            } else {
                size_units = ``;
                units = ``;
            }

        }
        let layout_array = `
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'slider',
            ${item.selector_value || item.selectors ? `'css' => [
                [
                    'property' => '${item.selector_value}',
                    'selector' => '${item.selectors}',
                ],
            ],` : ''}
            ${units}
            'default' => '${item.slider_defaultValue[1]}${item.slider_defaultValue[0]}',
            ${item.description ? `'description' => esc_html__( '${item.description}', '${textdomain}' ),` : ''}
            ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "dimension") {
        let default_val = ``;

        if (item.dimension_defaultValue) {
            if (item.dimension_defaultValue.isLinked == true) {
                default_val = `[
                    'top' => '${item.dimension_defaultValue.top}',
                    'right' => '${item.dimension_defaultValue.top}',
                    'bottom' => '${item.dimension_defaultValue.top}',
                    'left' => '${item.dimension_defaultValue.top}',
                ]`
            } else if (item.dimension_defaultValue.isLinked == false) {
                default_val = `[
                    'top' => '${item.dimension_defaultValue.top}',
                    'right' => '${item.dimension_defaultValue.right}',
                    'bottom' => '${item.dimension_defaultValue.bottom}',
                    'left' => '${item.dimension_defaultValue.left}',
                ]`
            }
        }

        let layout_array = `
       
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'dimensions',
            ${item.selector_value || item.selectors ? `'css' => [
                [
                    'property' => '${item.selector_value}',
                    'selector' => '${item.selectors}',
                ],
            ],` : ''}
            ${default_val ? `'default' => ${default_val},` : ''}
            ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "background") {
        let layout_array = `
    
        'tab' => '${tabs}',
        ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
        'type' => 'background',
        ${item.selector_value || item.selectors ? `'css' => [
            [
                'property' => 'background',
                'selector' => '${item.selectors}',
            ],
        ],` : ''}
        'small' => true,
        ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "border") {
        let layout_array = `
        
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'border',
            ${item.selector_value || item.selectors ? `'css' => [
                [
                    'property' => 'border',
                    'selector' => '${item.selectors}',
                ],
            ],` : ''}
            'small' => true,
            ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "typography") {
        let layout_array = `
        
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'typography',
            ${item.selector_value || item.selectors ? `'css' => [
                [
                    'property' => 'typography',
                    'selector' => '${item.selectors}',
                ],
            ],` : ''}
            ${Condition_function(item)}
            'popup' => true, 
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "textshadow") {
        let layout_array = `
       
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'text-shadow',
            ${item.selector_value || item.selectors ? `'css' => [
                [
                    'property' => 'text-shadow',
                    'selector' => '${item.selectors}',
                ],
            ],` : ''}

            ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "boxshadow") {
        let layout_array = `
        
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'box-shadow',
            ${item.selector_value || item.selectors ? `'css' => [
                [
                    'property' => 'box-shadow',
                    'selector' => '${item.selectors}',
                ],
            ],` : ''}
            'small' => true,
            ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "cssfilter") {
        let layout_array = `
       
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'filters',
            ${item.selector_value || item.selectors ? `'css' => [
                [
                    'property' => 'filter',
                    'selector' => '${item.selectors}',
                ],
            ],` : ''}
            ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "svg") {
        let layout_array = `
       
        'tab' => '${tabs}',
        'type' => 'svg',
        ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "datetime") {
        let layout_array = `
       
        'tab' => '${tabs}',
        ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
        'type' => 'datepicker',
        ${item.defaultValue ? `'default' =>  esc_html__( '${item.defaultValue}', '${textdomain}' ),` : ''}
        ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "code") {

        let layout_array = `
       
        'tab' => '${tabs}',
        ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
        'type' => 'code',
        'mode' => '${item.language}',
        ${item.defaultValue ? `'default' => '${item.defaultValue}',` : ''}
        ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }

    } else if (item.type == "gallery") {

        let layout_array = `

        'tab' => '${tabs}',
        ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
        'type' => 'image-gallery',
        ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }
    } else if (item.type == "align") {

        const Align = {
            'text-align': 'text-align',
            'justify-content': 'justify-content',
            'align-items': 'align-items',
            'flex-direction': 'direction',
        };

        // Assuming item.alignType is a valid key in Align
        const selectedAlignType = Align[item.alignType];


        let layout_array = `

        'tab' => '${tabs}',
        ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
        'type'  => '${selectedAlignType}',
        'options' => [
          'textAlign' => esc_html__( 'Text Align', 'bricks' ),
          'justifyContent' => esc_html__( 'Justify Content', 'bricks' ),
          'alignItems' => esc_html__( 'Align Items', 'bricks' ),
        ],
        ${Condition_function(item)}
        ${item.selector_value || item.selectors ? `'css' => [
            [
                'property' => '${item.selector_value}',
                'selector' => '${item.selectors}',
            ],
        ],` : ''}
        
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }
    } else if (item.type == "headingtags") {
        let options = [{ "value": "h1", "lable": "H1" }, { "value": "h2", "lable": "H2" }, { "value": "h3", "lable": "H3" }, { "value": "h4", "lable": "H4" }, { "value": "h5", "lable": "H5" }, { "value": "h6", "lable": "H6" }];
        var opt = ""
        options.map((data) => {
            opt += `'${data.value}'  => esc_html__( '${data.lable}', '${textdomain}' ),`
        })
        let layout_array = `
        
            'tab' => '${tabs}',
            ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
            'type' => 'select',
            'options' => [ ${opt} ],
            ${item.lableBlock === false ? '' : `'inline' =>${item.lableBlock},`}
            ${item.placeHolder ? `'placeholder' => esc_html__( '${item.placeHolder}', '${textdomain}' ),` : ''}
            'multiple' => false, 
            'searchable' => false,
            'clearable' => false,
            ${item.select_defaultValue[0] ? `'default' => '${item.select_defaultValue[0]}',` : ''}
            ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }
    } else if (item.type == "heading") {

        let layout_array = `

        'tab' => '${tabs}',
        ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
        'type' => 'info',
        ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }
    } else if (item.type == "switcher") {

        let layout_array = `

        'tab' => '${tabs}',
        ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
        'type' => 'checkbox',
        ${item.defaultValue ? `'default' => ${item.defaultValue},` : ''}
        ${Condition_function(item)}

        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }
    } else if (item.type == "wysiwyg") {

        let layout_array = `

        'tab' => '${tabs}',
        ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
        'type' => 'editor',
        'inlineEditing' => [
            'selector' => '.text-editor',
            'toolbar' => true,
        ],
        ${item.defaultValue ? `'default' => esc_html__( '${item.defaultValue}', '${textdomain}' ),` : ''} 
        ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }
    } else if (item.type == "query") {

        let layout_array = `

        'tab' => '${tabs}',
        ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
        'type' => 'query',
        'default' => [
            'post_type' => 'post',
        ],
        ${Condition_function(item)}

        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }
    } else if (item.type == "divider") {
        let layout_array = `

        'tab' => '${tabs}',
        ${item.lable ? `'label' => esc_html__( '${item.lable}', '${textdomain}' ),` : ''}
        'type' => 'separator',
        ${Condition_function(item)}
        `;

        if (repeater) {
            layout += `'${item.name}' => [
                ${layout_array}
            ],`
        } else {
            layout += `$this->controls['${item.name}'] = [
                ${layout_array}
            ]
            ;\n`
        }
    }

    return layout;
}